import React, { FC, useState } from 'react'
import { SmallButton, GhostButton, Toaster, Popover } from '@ui'
import { Position } from '@blueprintjs/core'
import css from './export.module.scss'
import { ImageFormatE } from '@hooks'

type ExportPropsT = {
  isLoading?: boolean
  onDownloadClick: (fileExtension: ImageFormatE) => void
}

const Export: FC<React.PropsWithChildren<ExportPropsT>> = ({
  onDownloadClick,
  isLoading = false,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)

  const openClosePopover = () => {
    if (isPopoverOpen) {
      closePopover()
    } else {
      openPopover()
      Toaster.warning({
        message: (
          <div>
            <strong>Export Image</strong>
            <br /> You can export a PDF or PNG of what is inside the red border
          </div>
        ),
        timeout: 100000,
      })
    }
  }

  const openPopover = () => {
    setIsPopoverOpen(true)
  }

  const closePopover = () => {
    setIsPopoverOpen(false)
  }

  const createOnExportClick = (fileExtension: ImageFormatE) => {
    return () => {
      onDownloadClick(fileExtension)
      closePopover()
      Toaster.success({ message: 'Floor plan is exporting', icon: undefined })
    }
  }

  return (
    <Popover
      minimal
      captureDismiss
      usePortal
      isOpen={isPopoverOpen}
      position={Position.BOTTOM}
      popoverClassName={css.popover}
      content={
        <>
          <GhostButton
            iconName="download"
            text="Export as PNG"
            onClick={createOnExportClick(ImageFormatE.png)}
          />
          <GhostButton
            iconName="download"
            text="Export as PDF"
            onClick={createOnExportClick(ImageFormatE.pdf)}
          />
        </>
      }>
      <SmallButton
        iconName="download"
        text="Export"
        onClick={openClosePopover}
        loading={isLoading}
      />
    </Popover>
  )
}

export default Export
